import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { URLLoader } from 'src/app/main/configs/URLLoader';
import MemberMessage from 'src/app/main/messages/MemberMessage';
import MemberTestService from 'src/app/main/mocks/MemberTestService';

import Member from 'src/app/main/models/Member';
import { HTTPService } from 'src/app/main/services/HTTPService';
import CONFIG from 'src/app/main/urls/urls';

@Component({
  selector: 'app-edit-member',
  templateUrl: './edit-member.component.html',
  styleUrls: ['./edit-member.component.css'],
})
export class EditMemberComponent implements OnInit {
  @Input() member: Member;
  memberForm: FormGroup;

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private memberService: HTTPService,
    private router: Router,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
  this.memberForm = this.fb.group({
    surname: ['', Validators.required],
    firstname: ['', Validators.required],
    dob: [''],
    age: [{ value: '', disabled: true }],
    gender: [''],
    admission_number: ['', Validators.required],
    class: ['', Validators.required],
    headOfDepartment: [''],
    address: [''],
    primary_phone: [''],
    primary_email: [''],
  });

    // Auto-calculate age whenever DOB changes (DOB itself stays optional)
    this.memberForm.get('dob').valueChanges.subscribe((dob) => {
      if (dob) {
        this.calculateAge(dob);
      } else {
        this.memberForm.get('age').setValue('', { emitEvent: false });
      }
    });

    if (this.member && this.member.id) {
      this.memberService.getAll(CONFIG.URL_BASE + '/member/' + this.member.id).subscribe((memberData: Member) => {
        this.memberForm.patchValue(memberData);
      });
    }
  }

  calculateAge(dob: string) {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    this.memberForm.get('age').setValue(`${age} years`, { emitEvent: false });
  }

  // Form submit handler that constructs the member object and sends it
  onSubmit() {
    const member = this.buildMemberObject();
    console.log(member)
    this.memberService.create(CONFIG.URL_BASE+'/member/create',member).then(() => {
      this.toastr.success('Item edited successfully!', 'Success');
      this.closeModal()
    });
  }

  closeModal(): void {
    this.activeModal.dismiss(); // Close the modal using NgbActiveModal
  }

  // Construct the member object from the form values
  buildMemberObject() {
    const formValues = this.memberForm.getRawValue();  // getRawValue() includes the disabled 'age' control

    const member = {
      id: this.member ? this.member.id : undefined,
      surname: formValues.surname,
      firstname: formValues.firstname,
      dob: formValues.dob || null,
      age: formValues.age || null,
      gender: formValues.gender || null,
      admission_number: formValues.admission_number,
      class: formValues.class,
      headOfDepartment: formValues.headOfDepartment,
      address: formValues.address,
      primary_phone: formValues.primary_phone,
      primary_email: formValues.primary_email,
    };

    return member;
  }

  onCancel() {
    this.closeModal()
  }
}